
import Button from '../../../components/base/Button';
import { useState } from 'react';

export default function AdvocacyCTASection() {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
    setIsSubscribed(true);
    setEmail('');
  };

  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.9), rgba(30, 58, 138, 0.9)), url('https://public.readdy.ai/ai/img_res/b0135f360208840592cd80c3519e8873.jpg')`
      }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Your Voice Matters in Healthcare Policy
        </h2>
        <p className="text-xl md:text-2xl mb-8">
          Join thousands of healthcare professionals who are actively shaping the future of Canadian healthcare through advocacy and policy development.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-megaphone-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2">Make Your Voice Heard</h3>
            <p className="text-white/90">
              Participate in campaigns that directly impact healthcare policy and professional practice.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2">Join a Community</h3>
            <p className="text-white/90">
              Connect with like-minded professionals who share your commitment to healthcare excellence.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-trophy-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2">Create Real Change</h3>
            <p className="text-white/90">
              Be part of successful advocacy efforts that have improved healthcare for millions of Canadians.
            </p>
          </div>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 mb-8">
          <h3 className="text-2xl font-bold mb-4">Stay Updated on Advocacy Efforts</h3>
          <p className="text-white/90 mb-6">
            Get the latest updates on advocacy campaigns, policy developments, and opportunities to get involved.
          </p>
          
          {!isSubscribed ? (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className="flex-1 px-4 py-3 rounded-lg text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white"
                required
              />
              <Button 
                type="submit"
                className="bg-white text-blue-900 hover:bg-gray-100 px-6 py-3 font-medium whitespace-nowrap"
              >
                Subscribe to Updates
              </Button>
            </form>
          ) : (
            <div className="bg-green-500/20 rounded-lg p-4 max-w-md mx-auto">
              <div className="flex items-center justify-center text-green-100">
                <i className="ri-check-circle-line text-xl mr-2"></i>
                <span>Thank you for subscribing to advocacy updates!</span>
              </div>
            </div>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button className="bg-white text-blue-900 hover:bg-gray-100 px-8 py-4 text-lg font-medium whitespace-nowrap">
            <i className="ri-hand-heart-line mr-2"></i>
            Join Advocacy Network
          </Button>
          <Button className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-4 text-lg font-medium whitespace-nowrap">
            <i className="ri-calendar-check-line mr-2"></i>
            View Active Campaigns
          </Button>
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/80 text-lg">
            Questions about advocacy? Contact our team at{' '}
            <a href="mailto:advocacy@cpva.ca" className="text-white underline hover:no-underline">
              advocacy@cpva.ca
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
